<template>
    <analytics-sidebar-box @reset="model = undefined">
        <template v-slot:title> Category </template>

        <category-filter-select
            size="sm"
            v-model="model"
            :options="analyticsCategoriesOptions"
            placeholder="All"
        ></category-filter-select>
    </analytics-sidebar-box>
</template>

<script lang="ts" setup>
import AnalyticsSidebarBox from './AnalyticsSidebarBox.vue';
import { analyticsCategoriesOptions } from '~/constants/categories';
import CategoryFilterSelect from '~/components/general/categories/CategoryFilterSelect.vue';

const model = defineModel({ required: true });
</script>
